const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const { GET_PROFILE, UPDATE_PROFILE } = require("./constants");

const {
  profileSuccess,
  profileError,

  updateProfileSuccess,
  updateProfileError,
} = require("./actions");

const profile = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PROFILE),
    mergeMap((action) =>
      marketplaceApi.customerProfile
        .profile(marketplace)
        .then((response) => profileSuccess(response.data))
        .catch((error) => profileError(error))
    )
  );

const updateProfile = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(UPDATE_PROFILE),
    mergeMap((action) =>
      marketplaceApi.customerProfile
        .updateProfile(
          marketplace,
          { user_id: action.payload.userId },
          {
            full_name: action.payload.fullname,
            username: action.payload.username,
            email: action.payload.email,
            phone: action.payload.phone,
          }
        )
        .then((response) => updateProfileSuccess(response.data))
        .catch((error) => updateProfileError(error))
    )
  );

module.exports = {
  profile,
  updateProfile,
};
